/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2023-08-01 14:40:55
 */

export const formatTitlesData = (titlesData) => {
  return titlesData.reduce((prev, cur) => {
    for (const item of prev) {
      if (cur.titleName === item.titleName) {
        item.titleId = item.titleId + ',' + cur.titleId
        return prev
      }
    }
    prev.push(cur)
    return prev
  }, [])
}

export const sensorsClassification = (folderRule) => {
  return folderRule === 'customize'
    ? 'custom'
    : folderRule === 'date'
      ? 'date'
      : folderRule === 'user'
        ? 'member'
        : 'notClassification'
}

export const sensorsNamingMethod = (namingRule) => {
  return namingRule.map((rule) => {
    if (rule.includes('title')) {
      return rule.split('title:')[1]
    } else if (rule.includes('diy')) {
      return '自定义标签'
    } else {
      switch (rule) {
        case 'user':
          return '拍摄人姓名'
        case 'time':
          return '拍摄时间'
        case 'address':
          return '拍摄地点'
        case 'watermark':
          return '水印模板'
        case 'photoNumber':
          return '照片编号'
        default:
          return ''
      }
    }
  })
}

export const calcCheckedPhotoNum = (photoState) => {
  const checkedPhotos = photoState.checkedPhotos
  const unCheckedPhotos = photoState.unCheckedPhotos
  const photosNum = photoState.photosNum
  const checkAll = photoState.checkAll

  const checkedPhotosSize = Object.keys(checkedPhotos).length
  const unCheckedPhotosSize = Object.keys(unCheckedPhotos).length

  if (checkAll) {
    return photosNum - unCheckedPhotosSize
  } else {
    return checkedPhotosSize
  }
}
